import { FormSelectionCardGroupField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SelectionCardGroupProps } from '@optimus-web/core';
import { IdentityProviderType } from '@mews-commander/data-access';

interface SsoIdentityProviderFieldProps
    extends Omit<SelectionCardGroupProps, 'cardVariant' | 'options' | 'compact' | 'onChange' | 'type' | 'inputValue'> {
    name: string;
}

export const SsoIdentityProviderField = ({ name, ...props }: SsoIdentityProviderFieldProps) => {
    const identityOptions = getIdentityProviderOptions(name);

    return (
        <FormSelectionCardGroupField
            name={name}
            label={<LocalizedText textKey={TextKey.SsoSetupIdentityProvider} />}
            type="radio"
            cardVariant="horizontal"
            options={identityOptions}
            required
            templateColumns="1fr 1fr"
            {...props}
        />
    );
};

const identityData = [
    {
        label: <LocalizedText textKey={TextKey.MicrosoftAzure} />,
        value: IdentityProviderType.MicrosoftAzure,
    },
    {
        label: <LocalizedText textKey={TextKey.GoogleAuthenticator} />,
        value: IdentityProviderType.GoogleWorkspace,
    },
];

const getIdentityProviderOptions = (name: string) =>
    identityData.map(({ label, value }) => ({
        label,
        value,
        name,
    }));
